export const ERROR_PROMOTION_OVERRIDDEN = 'error_discount_overridden_by_promo'

export const isPromotionError = (error: string) =>
  error === ERROR_PROMOTION_OVERRIDDEN
